import { Component, OnInit, Input, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder,Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ApiService, ABCisApi } from 'src/app/handlers/apiHandler.service';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatStepper } from '@angular/material/stepper';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { JobConfiguration } from 'src/app/models/job';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import * as moment from 'moment';
import { HttpStatus, OcrJob, OcrChannel } from 'src/app/constants/constants';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ConfigurationPage } from '../ConfigurationPage';
import { LoggerService } from 'src/app/handlers/logger.service';
import { Dataset } from 'src/app/components/abcis-table/abcis-table.component';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared/shared.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  templateUrl: './category-data-job.component.html',
  selector: 'category-data-job',
  standalone: false,
  styleUrls: ['./category-data-job.component.scss'],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-AU'},
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: {
      parse: {
        dateInput: ['l', 'LL'],
      },
      display: {
        dateInput: 'L',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
      }
    }
    }]
})

export class CategoryDataJobComponent implements OnInit, ConfigurationPage, AfterViewInit {
  @Input('jobValue') currentInputDocument: JobConfiguration;
  isloading: boolean;
  @ViewChild('discardConfirmationDialog') discardConfirmationDialog;

  uuid: string;
  hasUuid = false;
  pdfWidth: number = null;

  ////// Config Form
  configForm: FormGroup;
  storeVal = 'Loading configuration...';

  // ABN - Supplier - Keyword
  mappingOriginalLookup: ABNLookup[] = [];
  mappingLookup: ABNLookup[];
  mappingValue: ABNLookup;
  mappingText = '';
  hasMappingSelected = false;

  // Document Type
  documentTypes: Dataset[];

  // Document Date
  documentDateIsValid: boolean;
  maxDate = new Date(2020, 1, 1);

  // Stamps
  stamps: Dataset[];

  // Departments
  departments: Dataset[];

  hasConfigured = false;

  /////// Supplier Mapping Form
  supplierMappingForm: FormGroup;

  // Abn
  abnOriginalLookup: GlobalABN[] = [];
  abnLookup: GlobalABN[];
  abnCreateIsValid = false;
  abnValue: GlobalABN;
  abnIsSelected = false;
  abnButtonIcon = 'add';
  abnButtonDisabled = false;

  // Global Supplier
  globalSupplierOriginalLookup: GlobalSupplier[] = [];
  globalSupplierLookup: GlobalSupplier[] = [];
  globalSupplierValue: GlobalSupplier;
  globalSupTextValue = '';
  globalSupplierIsSelected = false;

  // Supplier Key
  supplierKeyValue: string;

  ////// Global Supplier Form
  supplierForm: FormGroup;

  // Supplier Name
  supplierValue: string;

  // Submit Buttons
  categorySubButton: SubmitButton = new SubmitButton('Apply');
  supMappingSubButton: SubmitButton = new SubmitButton('Create Mapping');
  globalSupSubButton: SubmitButton = new SubmitButton('Create Supplier');
  storeSupSubButton: SubmitButton = new SubmitButton('Apply Configuration');
  lineItemsSubButton: SubmitButton = new SubmitButton('Apply Configuration');
  supStoreTypeSubButton: SubmitButton = new SubmitButton('Apply Configuration');

  // Document Configurations
  supplierStoreConfigButton: ConfigButton = new ConfigButton();
  supplierTypeConfigButton: ConfigButton = new ConfigButton();
  supplierStoreTypeConfigButton: ConfigButton = new ConfigButton();

  //// Store Supplier Form
  storeSupplierForm: FormGroup;

  // Store Supplier Lookup
  storeSupOriginalLookup: StoreSupplier[] = [];
  storeSupLookup: StoreSupplier[] = [];
  storeSupValue: StoreSupplier;
  storeSupIsSelected = false;

  /// Line Items Form
  lineItemsForm: FormGroup;

  /// Supplier Store Type Form
  supStoreTypeConfigurationForm: FormGroup;

  defaultOrderFlags: Dataset[];
  selectedChannelId: number;

  btnSendDocumentLabel: string;
  btnSendChannelId: number;

  isDepartmentRequired = false;

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private apiHandler: ApiService,
              private toastr: ToastrService,
              private logger: LoggerService,
              private sharedService: SharedService,
              private dialog: MatDialog) { }

  ngOnInit(): void {
    this.sharedService.sharedChannel.subscribe(channel => this.selectedChannelId = channel);
  }

  // Add this method to ensure proper layout on component init
  ngAfterViewInit(): void {
    // Ensure consistent layout after view initialization
    setTimeout(() => {
      const formContainer = document.querySelector('.invoice-form-container') as HTMLElement;
      if (formContainer) {
        formContainer.style.width = '430px';
        formContainer.style.flexBasis = '430px';
      }
    }, 100);
  }

  async getNextFile(): Promise<void> {
    this.isloading = true;

    try {
      if(this.selectedChannelId == OcrChannel.WEB_UI) {
        this.btnSendDocumentLabel = 'Send to Supervisor';
        this.btnSendChannelId = OcrChannel.WEB_UI_ADMIN;
      } else{
        this.btnSendDocumentLabel = 'Send to Staff';
        this.btnSendChannelId = OcrChannel.WEB_UI;
      }

      const httpResponse = await this.apiHandler.getABCisRequest<JobConfiguration>(
        ABCisApi.Ocr,
        `job/${OcrJob.EXTRACT_CATEGORY_DATA}/next-document?channelId=${this.selectedChannelId}`
      );

      if (httpResponse.status != HttpStatus.NO_CONTENT) {
        this.currentInputDocument = httpResponse.body;
        this.configureInputDocument();
      } else {
        this.currentInputDocument = undefined;
        this.toastr.info('No more files available for Category job');
      }
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.toastr.error(httpError.error?.message || 'Failed to fetch next file');
    } finally {
      this.isloading = false;
    }
  }

  configureInputDocument(): void {
    this.configureMainConfigForm();
    this.configureDocNumConfig();
    this.SetupConfigurationPhase();
    this.configureSupplierMappingForm();
    this.configureCoreConfigurations();
    this.configureLookups();
    this.resetButtons();
  }

  configureDocNumConfig(): void {
    this.configForm.get('documentType').valueChanges.subscribe(value => {
      if ('S' === value){
        this.configForm.controls.documentNumber.clearValidators();
      }else{
        this.configForm.controls.documentNumber.setValidators(Validators.required);
      }
      this.configForm.controls.documentNumber.updateValueAndValidity();
    });
  }

  configureMainConfigForm(): void {
    this.configForm  =  this.formBuilder.group({
      mapping: ['', [Validators.required, this.validateSelect()]],
      documentNumber: ['', this.currentInputDocument.ocrDocumentTypeCode === 'S' ? '' : [Validators.required]],
      stamp: [''],
      documentType: ['', [Validators.required]],
      documentDate: ['', [Validators.required]],
      department: ['', [Validators.required]]
    });

    this.configForm.reset();
    this.configForm.get('documentNumber').setValue(this.currentInputDocument.ocrDocumentNumber);
    this.configForm.get('documentDate').setValue((this.currentInputDocument.ocrDocumentDate != null)? moment((this.currentInputDocument.ocrDocumentDate),'YYYY-MM-DD').format('DD/MM/YYYY'): '');
    this.configForm.get('stamp').setValue(this.currentInputDocument.ocrStampCode);
    this.configForm.get('documentType').setValue(this.currentInputDocument.ocrDocumentTypeCode);
    this.configForm.get('department').setValue(this.currentInputDocument.ocrDepartment);

    const event = { value: this.currentInputDocument.ocrDepartment };
    this.validateDepartmentSelect(event);

    const ocrDepartment = this.configForm.get('department')?.value;
    const globalSupplierStoreMapId = this.currentInputDocument.documentConfiguration.globalSupplierStoreMapId;
    if(globalSupplierStoreMapId != null) {
      this.checkDepartmentRequirement(globalSupplierStoreMapId, ocrDepartment);
    }
  }

  private async checkDepartmentRequirement(globalSupplierStoreMapId: any, ocrDepartment: any): Promise<void> {
    try {
      const httpResponse = await this.apiHandler.getABCisRequest(ABCisApi.Support, `global-supplier-store-department/${globalSupplierStoreMapId}/exists`);
      if(httpResponse.body && ocrDepartment !== 'DEFAULT') {
        this.isDepartmentRequired = true;
      } else {
        this.isDepartmentRequired = false;
      }
    } catch (error) {
      this.logger.error('Failed to check department requirement', error);
    }
  }

  configureSupplierMappingForm(): void {
    this.supplierMappingForm = this.formBuilder.group({
      abn: ['', [Validators.required]],
      supplierKey: [''],
      globalSupplier: ['', [Validators.required]]
    });
    this.supplierMappingForm.reset();
    this.globalSupplierIsSelected = false;
    this.abnIsSelected = false;
    this.supplierMappingForm.get('abn').setValue(this.currentInputDocument.ocrAbn);

    this.supplierForm = this.formBuilder.group({
      supplierName: ['', [Validators.required]],
      invoiceSupplierName: [''],
    });
    this.supplierForm.reset();
  }

  @HostListener('window:beforeunload', ['$event'])
  OnClose($event: any): void {
    if(this.currentInputDocument !== undefined) $event.returnValue = 'Are you sure you want to leave?';
  }

  ReleaseDocument(): void {
    this.releaseFile();
  }

  async releaseFile(): Promise<void> {
    this.isloading = true;
    try {
      await this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/release`, undefined);
      this.currentInputDocument = undefined;
    } catch (error) {
      this.logger.error(`Failed to release file: ${error.message || error}`);
    } finally {
      this.isloading = false;
    }
  }

  changePdfWidth(num: number): void {
    this.pdfWidth = num;
    // Ensure form container maintains its width
    const formContainer = document.querySelector('.invoice-form-container') as HTMLElement;
    if (formContainer) {
      formContainer.style.width = '430px';
      formContainer.style.flexBasis = '430px';
    }
  }


  stepperstep(stepper: MatStepper, step: number): void {
    stepper.selectedIndex = step;
  }

  configureCoreConfigurations(): void {
    this.uuid = this.currentInputDocument.uuid;
    this.hasConfigured = false;
    this.storeVal = `${this.currentInputDocument.storeId} - ${this.currentInputDocument.storeName}`;
    this.hasUuid = (this.uuid != '');
  }

  resetButtons(): void {
    this.categorySubButton.reset();
    this.supMappingSubButton.reset();
    this.globalSupSubButton.reset();
    this.storeSupSubButton.reset();
    this.lineItemsSubButton.reset();
    this.supStoreTypeSubButton.reset();
  }

  async configureLookups(): Promise<void> {
    try {
      const [mappingResponse, documentTypesResponse, stampsResponse, departmentsResponse, abnResponse, globalSupplierResponse, storeSupplierResponse, orderFlagsResponse] = await Promise.all([
        this.apiHandler.getABCisRequest<ABNLookup[]>(ABCisApi.Support, 'global-supplier-abn/extended-lookup'),
        this.apiHandler.getABCisRequest<Dataset[]>(ABCisApi.Support, 'document-type/lookup'),
        this.apiHandler.getABCisRequest<Dataset[]>(ABCisApi.Support, 'stamp/lookup'),
        this.apiHandler.getABCisRequest<Dataset[]>(ABCisApi.Support, 'global-department/lookup'),
        this.apiHandler.getABCisRequest<GlobalABN[]>(ABCisApi.Support, 'global-abn'),
        this.apiHandler.getABCisRequest<GlobalSupplier[]>(ABCisApi.Support, 'global-supplier'),
        this.apiHandler.getABCisRequest<StoreSupplier[]>(ABCisApi.Support, `store-supplier/extended-lookup?storeId=${this.currentInputDocument.storeId}`),
        this.apiHandler.getABCisRequest<Dataset[]>(ABCisApi.Support, 'order-flag/lookup')
      ]);

      this.mappingOriginalLookup = mappingResponse.body;
      this.mappingLookup = this._filter_mapping('');
      this.checkMapping();

      this.documentTypes = documentTypesResponse.body;
      this.stamps = stampsResponse.body;
      this.departments = departmentsResponse.body;

      this.abnOriginalLookup = abnResponse.body;
      this.abnLookup = this._filter_globalabn('');
      this.checkABNs();

      this.globalSupplierOriginalLookup = globalSupplierResponse.body;
      this.globalSupplierLookup = this._filter_globalsupplier('');

      this.storeSupOriginalLookup = storeSupplierResponse.body;
      this.storeSupLookup = this._filter_storesupplier('');

      this.defaultOrderFlags = orderFlagsResponse.body;
    } catch (error) {
      console.error('Error in configureLookups:', error);
    }
  }

  stepChanged(event: any, stepper: MatStepper): void {
    stepper.selected.interacted = false;
  }

  mappingInput(event: any): void {
    this.hasMappingSelected = false;
    const inputValue = (event.target as HTMLInputElement).value;
    this.mappingText = inputValue;
    this.mappingLookup = [];

    if (inputValue.length >= 3) {
      this.mappingLookup = this._filter_mapping(inputValue);
    }
  }

  onMappingLookupSelected(val: ABNLookup): void {
    this.hasMappingSelected = true;
    this.mappingValue = val;
    this.configForm.get('mapping').setValue(`${val.abn}/${val.supplierName}/${(val.keyword == null)? '': val.keyword}`);
  }

  _filter_mapping(val: string): ABNLookup[] {
    if (val === '') return [];
    return this.mappingOriginalLookup.filter(
      option => option.abn.indexOf(val) === 0 ||
        option.supplierName.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
        (option.keyword != null && option.keyword.toLowerCase().indexOf(val.toLowerCase()) > -1)
    );
  }

  checkMapping(): void {
    this.mappingOriginalLookup.forEach((val: ABNLookup) => {
      if (val.abn == this.currentInputDocument.ocrAbn
        && val.keyword == this.currentInputDocument.ocrKeyword) {
        this.onMappingLookupSelected(val);
        return;
      }
    });
  }

  checkABNs(): void {
    this.abnOriginalLookup.forEach((val: GlobalABN) => {
      if (val.abn == this.currentInputDocument.ocrAbn) {
        this.onAbnSelected(val);
        return;
      }
    });
    this.abnInput(this.supplierMappingForm.value.abn);
  }

  abnInput(value: string): void {
    this.abnLookup = this._filter_globalabn(value);
    this.abnIsSelected = false;
    if (value.length == 11) {
      if (this.abnLookup.length == 0) {
        if(this.validAbn(value)) {
          this.abnCreateIsValid = true;
        }
      }
      if (this.abnLookup.length == 1 && this.abnLookup[0].abn == value) {
        this.onAbnSelected(this.abnLookup[0]);
      }
    } else {
      this.abnCreateIsValid = false;
    }
  }

  abnCheck(event: any): boolean {
    if (event.target.value.length >= 11) {
      return false;
    }
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  validAbn(val: string): boolean {
    const weight= [ 10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19 ];
    let weightedSum = 0;
    for (let i = 0; i < weight.length; i++)
    {
      weightedSum += (parseInt(val[i]) - (i == 0 ? 1 : 0)) * weight[i];
    }
    return weightedSum % 89 == 0;
  }

  _filter_globalabn(val: string): GlobalABN[] {
    if (val === '') return [];
    return this.abnOriginalLookup.filter( option => option.abn.indexOf(val) === 0);
  }

  onAbnSelected(val: GlobalABN): void {
    this.abnValue = val;
    this.abnIsSelected = true;
    this.abnCreateIsValid = false;
    this.supplierMappingForm.get('abn').setValue(val.abn);
  }

  async addAbn(): Promise<void> {
    this.abnButtonIcon = 'refresh';
    this.abnButtonDisabled = true;

    try {
      const response = await this.apiHandler.postABCisRequest<any>(ABCisApi.Support, 'global-abn', {abn: this.supplierMappingForm.value.abn});

      if (response.body.globalAbnId !== undefined) {
        this.abnValue = new GlobalABN();
        this.abnValue.globalAbnId = response.body.globalAbnId;
        this.abnValue.abn = response.body.abn;
        this.abnIsSelected = true;
        this.abnCreateIsValid = false;
        this.abnButtonIcon = 'add';
        this.abnButtonDisabled = false;
      }
    } catch (error) {
      this.abnButtonIcon = 'warning';
      this.abnButtonDisabled = false;
      this.abnIsSelected = false;
    }
  }

  validateSelect(): ValidatorFn  {
    return (control: AbstractControl): {[key: string]: any} | null => {
      return !this.hasMappingSelected ? {'value':{ value: this.hasMappingSelected} }: null;
    };
  }

  async validateDepartmentSelect(event: any): Promise<void> {
    const departmentName = event.value;
    const globalSupplierStoreMapId = this.currentInputDocument.documentConfiguration.globalSupplierStoreMapId;
    if (!globalSupplierStoreMapId) {
      this.handleDepartmentValidationError(this.configForm.controls['department'].value !== 'DEFAULT');
      return;
    }

    try {
      const httpResponse = await this.apiHandler.getABCisRequest(ABCisApi.Support, `global-supplier-store-department/${globalSupplierStoreMapId}/department/${departmentName}`);
      if(!httpResponse.body) {
        const hasError = !httpResponse.body;
        this.handleDepartmentValidationError(hasError);
      }
    } catch (error) {
      this.configForm.controls['department'].setErrors({ departmentInvalid: true });
      this.handleDepartmentValidationError(true);
    }
  }

  handleDepartmentValidationError(isInvalid: boolean): void {
    if (isInvalid) {
      this.configForm.controls['department'].setErrors({ departmentInvalid: true });
    } else {
      this.configForm.controls['department'].setErrors(null);
    }
    this.configForm.controls['department'].markAsTouched();
  }

  imputFormatDate(iso: any): void {
    if (iso.split('/').length == 3 && iso.split('/')[2].length > 1) {
      this.validateDocumentDate(true);
    } else {
      this.validateDocumentDate(false);
    }
  }

  toFormattedDate(iso: any): void {
    const date = new Date(iso);
    this.validateDocumentDate(true);
    this.configForm.get('documentDate').setValue(moment(date).format('DD/MM/YYYY'));
  }

  validateDocumentDate(isValid: boolean): void {
    if (!isValid || !moment((this.configForm.value.documentDate),'DD/MM/YYYY').isValid()) {
      this.configForm.controls['documentDate'].setErrors({'incorrect': true});
    } else {
      this.configForm.controls['documentDate'].setErrors(null);
    }
  }

  async submitCategoryData(): Promise<void> {
    this.categorySubButton.setSubmit();
    if (!moment((this.configForm.value.documentDate),'DD/MM/YYYY').isValid()) {
      this.categorySubButton.setError('Invalid Date');
      return;
    }

    const categoryData: CategoryData = {
      abn: this.mappingValue.abn,
      supplierKeyword: this.mappingValue.keyword,
      documentTypeCode: this.configForm.value.documentType,
      documentDate: moment((this.configForm.value.documentDate),'DD/MM/YYYY').format('YYYY-MM-DD'),
      documentNumber: this.configForm.value.documentNumber,
      stampCode: this.configForm.value.stamp,
      departmentName: this.configForm.value.department
    };

    try {
      await this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.uuid}/document-data?assignToNextJob=false`, {categoryData: categoryData});
      this.ResetConfiguration();
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.categorySubButton.setError(httpError.error?.message || 'Failed to submit category data');
    }
  }

  async ResetConfiguration(): Promise<void> {
    try {
      const response = await this.apiHandler.getABCisRequest<any>(ABCisApi.Ocr, `document/${this.uuid}/configuration`);
      this.currentInputDocument.documentConfiguration = response.body;
      this.SetupConfigurationPhase();
      this.categorySubButton.setSuccess();
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.categorySubButton.setError(httpError.error?.message || 'Failed to reset configuration');
    }
  }

  globalSupplierInput(event: any): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.globalSupTextValue = inputValue;
    this.globalSupplierIsSelected = false;
    this.globalSupplierLookup = [];

    if (inputValue.length >= 3) {
      this.globalSupplierLookup = this._filter_globalsupplier(inputValue);

      this.globalSupplierLookup.forEach((supplier: GlobalSupplier) => {
        if (supplier.supplierName &&
            supplier.supplierName.toLowerCase() === inputValue.toLowerCase()) {
          this.onGlobalSupplierSelected(supplier);
          return;
        }
      });
    }
  }

  _filter_globalsupplier(val: string): GlobalSupplier[] {
    if (val === '') return [];
    return this.globalSupplierOriginalLookup.filter(option => option.supplierName.toLowerCase().indexOf(val.toLowerCase()) >= 0);
  }

  onGlobalSupplierSelected(val: GlobalSupplier): void {
    this.globalSupplierValue = val;
    this.globalSupplierIsSelected = true;
    this.globalSupTextValue = val.supplierName;
    this.supplierMappingForm.get('globalSupplier').setValue(val.supplierName);
  }

  async submitSupplierMappingConfiguration(stepper: MatStepper): Promise<void> {
    this.supplierKeyValue = this.supplierMappingForm.value.supplierKey;
    const template = this.getTemplate(this.globalSupplierValue.supplierName, this.supplierKeyValue);
    if (!this.supMappingSubButton.isSubmitting) {
      this.supMappingSubButton.setSubmit();
      const map: GlobalSupplierMapping = {
        globalAbnId: this.abnValue.globalAbnId,
        keyword: this.supplierKeyValue == null ? '' : this.supplierKeyValue,
        globalSupplierId: this.globalSupplierValue.globalSupplierId,
        ezeTemplateName: template == null ? '' : template
      };

      try {
        await this.apiHandler.postABCisRequest<any>(ABCisApi.Support, 'global-supplier-abn', map);
        this.hasMappingSelected = true;
        this.configForm.get('mapping').setValue(`${this.abnValue.abn}/${this.globalSupplierValue.supplierName}/${map.keyword}`);
        this.mappingValue = new ABNLookup();
        this.mappingValue.abn = this.abnValue.abn;
        this.mappingValue.keyword = map.keyword;
        this.supMappingSubButton.setSuccess();
        this.stepperstep(stepper, 0);
      } catch (error) {
        const httpError = error as HttpErrorResponse;
        this.supMappingSubButton.setError(httpError.error?.message || 'Failed to create supplier mapping');
      }
    }
  }

  getTemplate(supplierName: string, supplierKeyValue: string): string {
    let str = supplierName;
    if (supplierKeyValue != null && supplierKeyValue != '') {
      str += ' ' + supplierKeyValue;
    }
    return str;
  }

  async submitSupplierConfiguration(stepper: MatStepper): Promise<void> {
    const supplierName = new NewSupplier();
    supplierName.supplierName = this.supplierForm.get('supplierName').value;
    supplierName.invoiceSupplierName = this.supplierForm.get('invoiceSupplierName').value;
    this.globalSupSubButton.setSubmit();

    try {
      const response = await this.apiHandler.postABCisRequest(ABCisApi.Support, 'global-supplier', supplierName);
      this.globalSupSubButton.setSuccess();
      // Fix: Cast response.body to GlobalSupplier type
      this.onGlobalSupplierSelected(response.body as GlobalSupplier);
      this.stepperstep(stepper, 1);
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.globalSupSubButton.setError(httpError.error?.message || 'Failed to create supplier');
    }
  }

  SetupConfigurationPhase(): void {
    this.hasConfigured = true;
    this.ConfigureSupplierStore();
    this.ConfigureSupplierType();
    this.ConfigureSkipLineItems();
  }

  ConfigureSupplierStore(): void {
    this.storeSupplierForm = this.formBuilder.group({
      storeSupplier: ['', [Validators.required]],
      documentNumberSupplierPrefix: [''],
      freightPluExGst: [''],
      freightPluIncGst: [''],
      productMatchOnOrderCode : [''],
      cleanCreditLineItems : ['']
    });
    this.storeSupIsSelected = false;
    this.storeSupplierForm.reset();

    this.CheckStoreSupplier();

    this.storeSupplierForm.get('productMatchOnOrderCode').setValue(this.currentInputDocument.documentConfiguration.productMatchOnOrderCode);
    this.storeSupplierForm.get('cleanCreditLineItems').setValue(this.currentInputDocument.documentConfiguration.cleanCreditLineItems);
    this.storeSupplierForm.get('documentNumberSupplierPrefix').setValue(this.currentInputDocument.documentConfiguration.documentNumberSupplierPrefix);
    this.storeSupplierForm.get('freightPluExGst').setValue(this.currentInputDocument.documentConfiguration.freightPluExGst);
    this.storeSupplierForm.get('freightPluIncGst').setValue(this.currentInputDocument.documentConfiguration.freightPluIncGst);

    if (this.currentInputDocument.documentConfiguration.globalSupplierStoreMapId == null) {
      this.supplierStoreConfigButton.setNotConfigured();
      this.storeSupplierForm.get('cleanCreditLineItems').setValue(
        (this.storeSupplierForm.value.cleanCreditLineItems == null)? false: this.storeSupplierForm.value.cleanCreditLineItems
      );
    } else {
      this.supplierStoreConfigButton.setConfigured();
    }
  }

  CheckStoreSupplier(): void {
    this.storeSupValue = null;
    this.storeSupOriginalLookup.forEach((val: StoreSupplier) => {
      if (val.supplierId == this.currentInputDocument.documentConfiguration.storeSupplierId) {
        this.onStoreSupplierSelected(val);
        return;
      }
    });
  }

  _filter_storesupplier(val: string): StoreSupplier[] {
    if (val === '') return [];
    return this.storeSupOriginalLookup.filter(option =>
      option.supplierName.toLowerCase().indexOf(val.toLowerCase()) >= 0
      || option.supplierCode.toLowerCase().indexOf(val.toLowerCase()) >= 0);
  }

  storeSupplierInput(event: any): void {
    this.storeSupIsSelected = false;
    this.storeSupLookup = this._filter_storesupplier(event.target.value);
    this.storeSupLookup.forEach((supplier: StoreSupplier) => {
      if (supplier.supplierName.toLowerCase() == event.target.value.toLowerCase()) {
        this.onStoreSupplierSelected(supplier);
        return;
      }
    });
  }

  onStoreSupplierSelected(val: StoreSupplier): void {
    this.storeSupValue = val;
    this.storeSupIsSelected = true;
    this.storeSupplierForm.get('storeSupplier').setValue(val.supplierName);
  }

  async submitStoreSupplierConfiguration(stepper: MatStepper): Promise<void> {
    this.storeSupSubButton.setSubmit();
    const map: GlobalSupplierStoreMapping = {
      globalSupplierAbnId: this.currentInputDocument.documentConfiguration.globalSupplierAbnId,
      storeId: this.storeSupValue.storeId,
      storeSupplierId: this.storeSupValue.supplierId,
      cleanCreditLineItems: this.storeSupplierForm.value.cleanCreditLineItems,
      documentNumberSupplierPrefix: this.storeSupplierForm.value.documentNumberSupplierPrefix,
      freightPluExGst: this.storeSupplierForm.value.freightPluExGst,
      freightPluIncGst: this.storeSupplierForm.value.freightPluIncGst
    };

    if (map.freightPluExGst != undefined) map.freightPluExGst.padStart(14, '0');
    if (map.freightPluIncGst != undefined) map.freightPluIncGst.padStart(14, '0');

    try {
      const response = await this.apiHandler.postABCisRequest<any>(ABCisApi.Support, 'global-supplier-store-map', map);
      this.currentInputDocument.documentConfiguration.globalSupplierStoreMapId = response.body.globalSupplierStoreMapId;
      this.storeSupSubButton.setSuccess();
      this.supplierStoreConfigButton.setConfigured();
      this.stepperstep(stepper, 0);
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.storeSupSubButton.setError(httpError.error?.message || 'Failed to configure store supplier');
    }
  }

  ConfigureSupplierType(): void {
    this.supStoreTypeConfigurationForm = this.formBuilder.group({
      defaultPriority: ['', [Validators.required]],
      defaultOrderFlag: ['', ],
      isDocumentDiscarded: ['', [Validators.required]],
      isEdiConfigured: ['', [Validators.required]],
      isPurchaseOrderNumberRequired: ['', [Validators.required]],
      isAutocompleteAllowed: ['', [Validators.required]]
    });
    this.supStoreTypeConfigurationForm.reset();

    this.supStoreTypeConfigurationForm.get('defaultPriority').setValue(this.currentInputDocument.documentConfiguration.defaultPriority);
    this.supStoreTypeConfigurationForm.get('defaultOrderFlag').setValue(this.currentInputDocument.documentConfiguration.defaultOrderFlag);
    this.supStoreTypeConfigurationForm.get('isDocumentDiscarded').setValue(this.currentInputDocument.documentConfiguration.isDocumentDiscarded);
    this.supStoreTypeConfigurationForm.get('isEdiConfigured').setValue(this.currentInputDocument.documentConfiguration.isEdiConfigured);
    this.supStoreTypeConfigurationForm.get('isPurchaseOrderNumberRequired').setValue(this.currentInputDocument.documentConfiguration.isPurchaseOrderNumberRequired);
    this.supStoreTypeConfigurationForm.get('isAutocompleteAllowed').setValue(this.currentInputDocument.documentConfiguration.isAutocompleteAllowed);

    if (!this.currentInputDocument.documentConfiguration.isGlobalSupplierStoreTypeConfigurationAvailable) {
      this.loadDefaultStoreTypeSettings();
      this.supplierStoreTypeConfigButton.setNotConfigured();
      this.supStoreTypeConfigurationForm.get('defaultPriority').setValue(
        (this.supStoreTypeConfigurationForm.value.defaultPriority == null)? 50: this.supStoreTypeConfigurationForm.value.defaultPriority
      );
      this.supStoreTypeConfigurationForm.get('isEdiConfigured').setValue(
        (this.supStoreTypeConfigurationForm.value.isEdiConfigured == null)? false: this.supStoreTypeConfigurationForm.value.isEdiConfigured
      );
      this.supStoreTypeConfigurationForm.get('isPurchaseOrderNumberRequired').setValue(
        (this.supStoreTypeConfigurationForm.value.isPurchaseOrderNumberRequired == null)? false: this.supStoreTypeConfigurationForm.value.isPurchaseOrderNumberRequired
      );
    } else {
      this.supplierStoreTypeConfigButton.setConfigured();
    }
  }

  private async loadDefaultStoreTypeSettings(): Promise<void> {
    try {
      const response = await this.apiHandler.getABCisRequest<DefaultStoreTypeSettings>(ABCisApi.Support, `default-store-type-settings/${this.currentInputDocument.storeId}/${this.currentInputDocument.ocrDocumentTypeCode}`);
      this.supStoreTypeConfigurationForm.get('defaultOrderFlag').setValue(response.body.defaultOrderFlag);
      this.supStoreTypeConfigurationForm.get('isPurchaseOrderNumberRequired').setValue(response.body.isPurchaseOrderNumberRequired);
      this.supStoreTypeConfigurationForm.get('isDocumentDiscarded').setValue(response.body.isDocumentDiscarded);
      this.supStoreTypeConfigurationForm.get('isAutocompleteAllowed').setValue(response.body.isAutocompleteAllowed);
    } catch (error) {
      this.supStoreTypeConfigurationForm.get('defaultOrderFlag').setValue('U');
      this.supStoreTypeConfigurationForm.get('isPurchaseOrderNumberRequired').setValue(false);
      this.supStoreTypeConfigurationForm.get('isDocumentDiscarded').setValue(false);
      this.supStoreTypeConfigurationForm.get('isAutocompleteAllowed').setValue(true);
    }
  }

  async submitSupStoreTypeConfiguration(stepper: MatStepper): Promise<void> {
    this.supStoreTypeSubButton.setSubmit();
    const map: GlobalSupplierStoreTypeConfiguration = {
      globalSupplierStoreMapId: this.currentInputDocument.documentConfiguration.globalSupplierStoreMapId,
      documentTypeCode: this.currentInputDocument.ocrDocumentTypeCode,
      defaultPriority: this.supStoreTypeConfigurationForm.value.defaultPriority,
      defaultOrderFlag: this.supStoreTypeConfigurationForm.value.defaultOrderFlag,
      isDocumentDiscarded: this.supStoreTypeConfigurationForm.value.isDocumentDiscarded,
      isEdiConfigured: this.supStoreTypeConfigurationForm.value.isEdiConfigured,
      isPurchaseOrderNumberRequired: this.supStoreTypeConfigurationForm.value.isPurchaseOrderNumberRequired,
      isAutocompleteAllowed: this.supStoreTypeConfigurationForm.value.isAutocompleteAllowed
    };

    try {
      await this.apiHandler.postABCisRequest(ABCisApi.Support, 'global-supplier-store-type-configuration', map);
      this.supStoreTypeSubButton.setSuccess();
      this.supplierStoreTypeConfigButton.setConfigured();
      this.stepperstep(stepper, 0);
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.supStoreTypeSubButton.setError(httpError.error?.message || 'Failed to configure supplier store type');
    }
  }

  pluCheck(event: any): boolean {
    if (event.target.value.length >= 14) {
      return false;
    }
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  ConfigureSkipLineItems(): void {
    this.lineItemsForm = this.formBuilder.group({
      skipLineItems: ['', [Validators.required]]
    });
    this.lineItemsForm.reset();
    this.lineItemsForm.get('skipLineItems').setValue(this.currentInputDocument.documentConfiguration.skipLineItems);
    if (!this.currentInputDocument.documentConfiguration.isGlobalSupplierTypeConfigurationAvailable) {
      this.supplierTypeConfigButton.setNotConfigured();
      this.lineItemsForm.get('skipLineItems').setValue(false);
    } else {
      this.supplierTypeConfigButton.setConfigured();
    }
  }

  async submitLineItemsConfiguration(stepper: MatStepper): Promise<void> {
    this.lineItemsSubButton.setSubmit();
    const map: GlobalSupplierType = {
      globalSupplierId: this.currentInputDocument.documentConfiguration.globalSupplierId,
      documentTypeCode: this.currentInputDocument.ocrDocumentTypeCode,
      skipLineItems: this.lineItemsForm.value.skipLineItems
    };

    try {
      await this.apiHandler.postABCisRequest(ABCisApi.Support, 'global-supplier-type-configuration', map);
      this.lineItemsSubButton.setSuccess();
      this.supplierTypeConfigButton.setConfigured();
      this.stepperstep(stepper, 0);
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.lineItemsSubButton.setError(httpError.error?.message || 'Failed to configure line items');
    }
  }

  checkIfFinished(): boolean {
    return (this.supplierStoreTypeConfigButton.isValid
      && this.supplierTypeConfigButton.isValid
      && this.supplierStoreConfigButton.isValid);
  }

  async finishJob(isNextjob: boolean): Promise<void> {
    try {
      await this.apiHandler.postABCisRequest<any>(ABCisApi.Ocr, `document/${this.uuid}/assign-to-next-job/`, undefined);

      if (isNextjob) {
        const response = await this.apiHandler.getABCisRequest<JobConfiguration>(ABCisApi.Ocr, `job/${OcrJob.EXTRACT_CATEGORY_DATA}/next-document?channelId=${OcrChannel.WEB_UI}`);

        if (response.status != HttpStatus.NO_CONTENT) {
          this.currentInputDocument = response.body;
          this.configureInputDocument();
        } else {
          this.currentInputDocument = undefined;
          location.reload();
        }
      } else {
        this.currentInputDocument = undefined;
        location.reload();
      }
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.supStoreTypeSubButton.setError(httpError.error?.message || 'Failed to finish job');
    }
  }

  async onDiscardClick(): Promise<void> {
    const dialogRef = this.dialog.open(this.discardConfirmationDialog);
    const result = await dialogRef.afterClosed().toPromise();

    if(result) {
      this.isloading = true;
      try {
        await this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/user-discard`);
        this.getNextFile();
      } catch (error) {
        const httpError = error as HttpErrorResponse;
        this.toastr.error(httpError.error?.message || 'Failed to discard document');
        this.isloading = false;
      }
    }
  }

  async onAllocateClick(): Promise<void> {
    this.isloading = true;
    try {
      await this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/to-allocator`);
      this.getNextFile();
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.toastr.error(httpError.error?.message || 'Failed to allocate document');
      this.isloading = false;
    }
  }

  async onRescanClick(): Promise<void> {
    this.isloading = true;
    try {
      await this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/request-rescan`);
      this.getNextFile();
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.toastr.error(httpError.error?.message || 'Failed to request rescan');
      this.isloading = false;
    }
  }

  async onSendToStaffOrSupervisor(): Promise<void> {
    this.isloading = true;
    try {
      await this.apiHandler.postABCisRequest(ABCisApi.Ocr, `document/${this.currentInputDocument.uuid}/to-staff-or-supervisor/${this.btnSendChannelId}`);
      this.getNextFile();
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.toastr.error(httpError.error?.message || 'Failed to send document');
      this.isloading = false;
    }
  }

  onGenerateABN(): void {
    // Simplified ABN generation without xml2js dependency
    const weights = [3,5,7,9,11,13,15,17,19];
    const randoms = [];

    for(let i = 0; i < 9; i++) {
      const random = Math.floor(Math.random() * 10);
      randoms.push(random);
    }

    let checksum = 0;
    for(let i = 0; i < randoms.length; i++) {
      checksum += (randoms[i] * weights[i]);
    }

    const remainder = checksum % 89;
    const startingDigits = (89 - remainder) + 10;
    const randomABN = startingDigits + '' + randoms.join('');

    this.configForm.get('mapping').setValue(randomABN);
    this.mappingText = this.configForm.get('mapping').value;
  }


}

class CategoryData {
  abn: string;
  supplierKeyword: string;
  documentTypeCode: string;
  documentDate: string;
  documentNumber: string;
  stampCode: string;
  departmentName: string;
}

class ABNLookup {
  abn: string;
  keyword: string;
  supplierName: string;
}

class DocumentType {
  documentTypeCode: string;
  documentTypeName: string;
}

class Stamp {
  stampCode: string;
  stamp: string;
}

class GlobalABN {
  globalAbnId: number;
  abn: string;
  searchRegex: string;
}

class GlobalSupplierMapping {
  globalAbnId: number;
  keyword: string;
  globalSupplierId: number;
  ezeTemplateName: string;
}

class GlobalSupplier {
  globalSupplierId: number;
  supplierName: string;
}

class NewSupplier {
  supplierName: string;
  invoiceSupplierName: string;
}

class SubmitButton {
  ButtonText: string;
  ButtonIcon: string;
  ButtonStatus: string;
  ErrorMessage: string;
  isSubmitting: boolean;
  resetText: string;

  constructor(val: string) {
    this.isSubmitting = false;
    this.ButtonStatus = 'disabled';
    this.resetText = val;
    this.ButtonText = val;
    this.ButtonIcon = 'more_horiz';
    this.ErrorMessage = undefined;
  }

  reset(): void {
    this.isSubmitting = false;
    this.ButtonStatus = 'disabled';
    this.ButtonText = this.resetText;
    this.ButtonIcon = 'more_horiz';
    this.ErrorMessage = undefined;
  }

  setSubmit(): void {
    this.isSubmitting = true;
    this.ButtonText = 'Submitting Data';
    this.ButtonStatus = 'submitting';
    this.ButtonIcon = 'refresh';
    this.ErrorMessage = undefined;
  }

  setSuccess(): void {
    this.isSubmitting = false;
    this.ButtonStatus = 'disabled';
    this.ButtonText = 'Successfully Applied';
    this.ButtonIcon = 'check';
    this.ErrorMessage = undefined;
  }

  setError(val: string): void {
    this.ButtonText = 'Something went wrong';
    this.ButtonIcon = 'warning';
    this.ButtonStatus = 'error';
    this.ErrorMessage = val;
    this.isSubmitting = false;
  }
}

class ConfigButton {
  ButtonIcon: string;
  ButtonIsClickable: boolean;
  isValid: boolean;

  setConfigured(): void {
    this.ButtonIsClickable = false;
    this.isValid = true;
    this.ButtonIcon = 'check';
  }

  setNotConfigured(): void {
    this.ButtonIsClickable = true;
    this.isValid = false;
    this.ButtonIcon = 'warning';
  }
}

class StoreSupplier {
  storeId: number;
  supplierId: number;
  supplierCode: string;
  supplierName: string;
  activeProductsCount: number;
  isDeleted: boolean;
}

class GlobalSupplierStoreMapping {
  globalSupplierAbnId: number;
  storeId: number;
  storeSupplierId: number;
  documentNumberSupplierPrefix: string;
  cleanCreditLineItems: boolean;
  freightPluExGst: string;
  freightPluIncGst: string;
}

class GlobalSupplierType {
  globalSupplierId: number;
  documentTypeCode: string;
  skipLineItems: boolean;
}

class GlobalSupplierStoreTypeConfiguration {
  globalSupplierStoreMapId: number;
  documentTypeCode: string;
  defaultPriority: number;
  defaultOrderFlag: string;
  isDocumentDiscarded: boolean;
  isEdiConfigured: boolean;
  isPurchaseOrderNumberRequired: boolean;
  isAutocompleteAllowed: boolean;
}

class DefaultStoreTypeSettings {
  storeId: number;
  documentTypeCode: string;
  defaultOrderFlag: string;
  isPurchaseOrderNumberRequired: boolean;
  isDocumentDiscarded: boolean;
  isAutocompleteAllowed: boolean;
}
